window.CardDeck = Component.extend({
    initialize: function(properties) {
        this.name = "CardDeck";
        this.wrapper = properties.wrapper;
        // this.audioManager = properties.audioManager;
        // this.listenTo(this.audioManager, "onAudioManagerReady", this.handleAudioManagerReady);
        this.render();
    },

    handleAudioManagerReady: function() {
        // this.audioManager.add("slidein", "assets/mp3/21803435_card-deck-shuffle_by_nguyen_christ_preview.mp3");
        // for (var i = 0; i < this.data.cards.length; i++) {
        //     this.audioManager.add("show_" + (i + 1), "assets/mp3/show_" + (i + 1) + ".mp3");
        // }
	},
	
	pause: function() {
		var tweens = TweenMax.getTweensOf([this, this.$cards, this.$instruction]);
		tweens.map( (item) => {
			return item.pause();
		});
		
	},
	resume: function() {
		var tweens = TweenMax.getTweensOf([this, this.$cards, this.$instruction]);
		tweens.map((item) => {
			return item.resume();
		});
	},

    setup: function(container) {
        this.container = container;
        // this.audioManager = this.container.audioManager;
        // this.handleAudioManagerReady();

        this.listenTo(this.container, "onLoadComplete", this.handleLoadComplete);
		this.listenTo(this.container, "onResizeComplete", this.handleResizeComplete);
		this.listenTo(this.container.session, "onResizeComplete", this.handleResizeComplete);
    },

    handleLoadComplete: function() {
        this.$instruction = this.$dom.find(".instruction");
        this.$instruction.find(".title").text(LanguageManager.getString("shuffle_title"));
        this.$instruction.find(".content").text(LanguageManager.getString("shuffle_content"));
        this.$cardDeck.attr("title", LanguageManager.getString("shuffle_instruction"));
        this.$cardDeck.attr("aria-label", LanguageManager.getString("shuffle_instruction"));
    },

    handleResizeComplete: function() {
        if (this.isExploded) {
            this.explodeCards(true);
        }
    },

    render: function() {
        this.data = this.getData();

        this.$content = $(this.getContent(this.data));
        this.$dom = $(this.wrapper).prepend(this.$content);

        this.setupVariables();
    },

    setupVariables: function() {
        this.$cardDeck = this.$content.find(".deck");
        this.$cards = this.$content.find(".card");
        this.zIndex = this.$cards.length;
        this.isExploded = false;
        this.xDistance = 0;
        this.yDistance = 6;
        this.lastIndex = 0;
        this.flipCardIndex = 0;
    },

    slideInCards: function() {
        var tl = new TimelineMax({
            onComplete: function(ref) {
                ref.trigger("onSlideInCardsComplete");
            },
            onCompleteParams: [this]
        });

        //if (this.audioManager) this.audioManager.play("slidein");

        _.each(this.$cards, function(card, i) {
            var $card = $(card);
            var rotation = _.random(-5, 5);
            TweenMax.set($card, {
                y: $card.height() * 3,
                opacity: 1,
                scale: 2,
                rotation: rotation,
                "z-index": i + 1
            });

            card.lastX = 0;
            card.lastY = 0;
            card.lastScale = 1;
            card.lastRotation = rotation;
            tl.to($card, 0.6, {
                x: 0,
                y: 0,
                ease: Power4.easeOut,
                onStart: function() {
                    if (self.audioManager) self.audioManager.play("show_" + (i + 1));
                }
            }, 0.05 * i).to($card, 0.6, {
                scale: 1,
                ease: Back.easeOut.config(0.5)
            }, 0.05 * i);
        });
    },

    flipCard: function() {
        var $card = $(this.$cards[this.flipCardIndex]);
        this.flipCardIndex++;
        this.animationComplete($card);
    },

    animationComplete: function($card) {
        var self = this;
        TweenMax.set($card, {
            x: ($card.width() * 1.6),
            y: 0,
            scale: 0.5,
            rotationX: 0,
            rotationY: 0,
            onComplete: function() {
                self.$cardDeck.addClass("hide-cards");
            }
        });

        this.trigger("onFlipCardsComplete");

    },

    slideOutCards: function() {
        var self = this;
        var tl = new TimelineMax({
            delay: 0.25,
            onComplete: function(ref) {
                ref.trigger("onSlideOutCardsComplete");
            },
            onCompleteParams: [this]
        });

        _.each(this.$cards, function(card, i) {
            var $card = $(card);

            tl.to($card, 0.4, {
                y: window.innerHeight,
                ease: Power3.easeIn,
                onStart: function() {
                    if (self.audioManager) self.audioManager.play("show_" + (i + 1));
                }

            }, i * 0.05);
        }, this);
    },

    slideOutCardsWithoutShuffle: function() {
        var tl = new TimelineMax({
            delay: 0.25,
            onComplete: function(ref) {
                ref.trigger("onSlideOutCardsComplete");
            },
            onCompleteParams: [this]
        });

        _.each(this.$cards, function(card, i) {
            var $card = $(card);
            tl.to($card, 0.4, {
                x: ($card.width() * 1.6),
                y: (this.$cards.length - i) * this.yDistance,
                scale: 1 - (this.$cards.length - i) * 0.01,
                rotation: 0,
                ease: Back.easeOut.config(0.5)
            }, i * 0.05);
        }, this);
    },

    enableTapToShuffle: function() {
        TweenMax.set(this.$instruction, {
            y: -10
        });

        TweenMax.to(this.$instruction, 0.3, {
            y: 0,
            opacity: 1,
            display: "block",
            ease: Power4.easeInOut
        });

        this.cardDeck = new Button({
            el: this.$cardDeck,
            buttonClass: "active"
        });
        this.listenTo(this.cardDeck, "onClick", this.handleDeckClick);
    },

    handleDeckClick: function() {
        var self = this;
        TweenMax.to(this.$instruction, 0.3, {
            opacity: 0,
            ease: Power4.easeInOut
        });

        this.container.$page.show();

        this.$cardDeck.removeClass("active");
        this.stopListening(this.cardDeck, "onClick");
        Accessibility.hide(this.$cardDeck);
        Accessibility.disable(this.$cardDeck);

        this.flipCardIndex = 0;
        this.shuffleCards(_.random(8, 10));
    },

    removeCardDeck: function() {
        this.$cardDeck.remove();
    },

    shuffleCards: function(count) {
        var self = this;
        var index = _.random(2, this.$cards.length - 1);
        if (index == this.lastIndex) {
            if (index < this.$cards.length - 1) {
                index += 1;
            } else {
                index -= 1;
            }
        }
        var direction = count % 2 ? 0 : 1;
        var $card = $(this.$cards[index]);
        var xPos = ((direction === 0) ? "+=" : "-=") + $card.width() * (_.random(2, 3) / 2);
        var yPos = "+=25";
        var rotation = (direction === 0) ? 5 : -5;
        var rotationEnd = (direction === 0) ? 1 : -1;

        //if (this.audioManager) this.audioManager.play("show_" + (index + 1));

		TweenMax.to($card, 0.25, {
			x: xPos,
			y: yPos,
			scale: 1.2,
			rotation: rotation,
			ease: Power4.easeIn,
			onComplete: function () {
				TweenMax.set($card, {
					"z-index": ++self.zIndex
				});
				TweenMax.to($card, 0.25, {
					x: 0,
					y: 0,
					rotation: rotationEnd,
					ease: Power4.easeOut
				});
				self.rearangeCards(index);
				count--;
				if (count > 0) {
					this.lastIndex = 1; // setting it to 1 as curret picked card with have swapped to this position by now
					self.shuffleCards(count);
				} else {
					self.slideOutCards();
				}
			}
		});
    },

    explodeCards: function(isAuto) {
        var self = this;
        var tl = new TimelineMax({
            onComplete: function(ref) {
                if (!isAuto) {
                    ref.trigger("onExplodeCardsComplete");
                }
            },
            onCompleteParams: [this]
        });
        _.each(this.$cards, function(card, i) {
            var $card = $(card);
            var $logo = $card.find(".logo");
            TweenMax.to($logo, 0.25, {
                opacity: 0,
                ease: Power4.easeOut,
                delay: (0.05 * (i + 1))
            });

            var cardWidth = $card.width();
            var xDiff = cardWidth;
            var windowWidth = window.innerWidth;
            if (cardWidth < windowWidth) {
                xDiff += ((windowWidth - cardWidth) / 3);
            }

            var cardHeight = $card.height();
            var yDiff = cardHeight;
            var windowHeight = window.innerHeight;
            if (cardHeight < windowHeight) {
                yDiff += ((windowHeight - cardHeight) / 3);
            }
            tl.to(card, 0.6, {
                x: CardDeck.directions[i].x * xDiff,
                y: CardDeck.directions[i].y * yDiff,
                rotation: CardDeck.angles[i] + _.random(10, 15),
                ease: Back.easeOut.config(0.5),
                onStart: function() {
                    if (self.audioManager) self.audioManager.play("show_" + (i + 1));
                }
            }, i * 0.05).to(card, 0.2, {
                scale: 1 - i * 0.01,
                ease: Back.easeOut.config(0.5)
            }, i * 0.05);
        }, this);

        this.isExploded = true;
    },

    contractCards: function() {
        var self = this;
        var tl = new TimelineMax({
            onComplete: function(ref) {
                ref.trigger("onContractCardsComplete");
            },
            onCompleteParams: [this]
        });

        _.each(this.$cards, function(card, i) {
            var $card = $(card);
            tl.to(card, 0.6, {
                x: card.lastX,
                y: card.lastY,
                opacity: 1,
                rotation: card.lastRotation,
                ease: Back.easeOut.config(0.5),
                onStart: function() {
                    if (self.audioManager) self.audioManager.play("show_" + (i + 1));
                }
            }, i * 0.05).to(card, 0.2, {
                scale: card.lastScale,
                ease: Back.easeOut.config(0.5)
            }, i * 0.05);
        }, this);

        this.isExploded = false;
    },

    rearangeCards: function(index) {
        
        // Swap the order of the items in the DOM
        var temp = this.$cards[index];
        for (var i = index; i > 0; i--) {
            this.$cards[i] = this.$cards[i - 1];
        }
        this.$cards[0] = temp;

        // Loop over the items and set the correct scale and zindex based on the new DOM order
        _.each(this.$cards, function(card, i) {
            var $card = $(card);
            TweenMax.to(card, 0.2, {
                scale: 1 - i * 0.01,
                zIndex: 30 - i,
                ease: Back.easeOut.config(0.5)
            });
        }, this);
    },

    getData: function() {
        var data = {};
        data.cards = [];
        for (var i = 0; i < 8; i++) {
            var colorIndex = Math.floor(i / 2);
            var card = {
                color: CardDeck.cardColor[colorIndex]
            };
            data.cards.push(card);
        }
        return data;
    },

    getContent: function(data) {
        return Handlebars.templates["components/carddeck"](data);
    },

    destroy: function() {
        this.$cardDeck.parent().remove();
        this.stopListening();
        this.off();
    }
}, {
    cardColor: ["orange", "purple", "teal", "yellow"],
    angles: [-45, -15, 20, 25, -15, -30, -45, -15, 20, 25, -15, -30],
    directions: [{
            x: -1.25,
            y: -0.5
        },
        {
            x: -0.25,
            y: -1.10
        },
        {
            x: 1,
            y: -0.75
        },
        {
            x: -1,
            y: 0.75
        },
        {
            x: 0.25,
            y: 1
        },
        {
            x: 1,
            y: 0.5
        }, {
            x: -1.25,
            y: -0.5
        },
        {
            x: -0.25,
            y: -1.10
        },
        {
            x: 1,
            y: -0.75
        },
        {
            x: -1,
            y: 0.75
        },
        {
            x: 0.25,
            y: 1
        },
        {
            x: 1,
            y: 0.5
        }
    ]
});
